module.exports = __webpack_public_path__ + "assets/18357f5f5a01aff8a301b20019353968.png";